import { render, staticRenderFns } from "./audioPlay.vue?vue&type=template&id=7839f53a&scoped=true&"
import script from "./audioPlay.vue?vue&type=script&lang=js&"
export * from "./audioPlay.vue?vue&type=script&lang=js&"
import style0 from "./audioPlay.vue?vue&type=style&index=0&id=7839f53a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7839f53a",
  null
  
)

export default component.exports